import {faMapMarked} from "@fortawesome/free-solid-svg-icons/faMapMarked";
import {faSearchLocation} from "@fortawesome/free-solid-svg-icons/faSearchLocation";
import {faClock} from "@fortawesome/free-solid-svg-icons/faClock";
import {faBox} from "@fortawesome/free-solid-svg-icons/faBox";
import {faCircleNotch} from "@fortawesome/free-solid-svg-icons/faCircleNotch";
import {faCircle, faHourglassHalf, faTruckLoading, faUndo} from "@fortawesome/free-solid-svg-icons";
import {faUsers} from "@fortawesome/free-solid-svg-icons/faUsers";
import { faUserShield } from '@fortawesome/free-solid-svg-icons';
import { faCogs } from '@fortawesome/free-solid-svg-icons';
import {faWarehouse} from '@fortawesome/free-solid-svg-icons/faWarehouse';
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { TranslateService } from '@ngx-translate/core';


export const KPIS: { [id: string]: any; } = {

  customerSummary: {
    'label': 'User Activity Summary',
    'link': '/dashboard/customer-summary',
    'icon': faUsers,
    'active': true,
    'description': ""
  },

  itemsLost: {
    'label': 'Items Lost',
    'link': '/dashboard/items-lost',
    'icon': faSearchLocation,
    'active': true,
    'description': {
      perSite: "Shows the total number of items per product and per site that is lost.<br/> Items are defined as 'lost' when there exists no RFID read within the last 90 days.",
      atSite: "Shows the total number of items per product that is lost.<br/> Items are defined as 'lost' when there exists no RFID read within the last 90 days.",
      topLocations: "Shows the top N locations with the highest number of lost items. Items are defined as 'lost' when there exists no RFID read within the last 90 days.",
      perProductType: "Shows the percentage of lost items per product type across all sites. Items are defined as 'lost' when there exists no RFID read within the last 90 days.",
      timeline: "Shows the total number of items per product that are defined 'lost' over a period of time."
    }
  },

  itemsAtLocation: {
    'label': 'Items at Site',
    'link': '/dashboard/items-at-site',
    'icon': faMapMarked,
    'active': true,
    'description': {
      atLocations: "itemsAtLocationatLocations",
      atCustomers: "itemsAtLocationatCustomers",
      perProduct: "itemsAtLocationperProduct",
      // atCustomers: "Shows the total number of items per Cintas customer. Only items (lost and circulating) that are registered at the customer at the moment are counted.",
      // perProduct: "Shows the total number of items (lost and circulating) per product and per site (i.e., at locations and at customers)."
    }
  },
  productLifetimeDelta: {
    'label': 'Product Lifetime Delta',
    'link': '/dashboard/product-lifetime-delta',
    'icon': faClock,
    'active': true,
    // 'description': "productLifetimeDelta description"
    'description': "Shows the average lifetime delta of items per product (measured in cycle count).<br/> The lifetime delta in cycle count is computed as the difference between the expected lifetime of an item (as defined in the app for each product) and the actual lifetime when an item is marked as 'dismissed' in the app."
  },
  avgTurnaroundTime: {
    'label': 'Avg. Turnaround Time',
    'link': '/dashboard/avg-turnaround-time',
    'icon': faCircleNotch,
    'active': true,
    'description': "avgTurnaroundTime description"
    // 'description': "Shows the avg. number of item turnarounds per product in a period and the average time in days between delivery and return.<br/> The average turnaround time in days is computed by computing the difference between delivery and return over all deliveries and for all items and averaging the deltas per product."
  },
  productAgeSummary: {
    'label': 'Product Age Summary',
    'link': '/dashboard/age-summary',
    'icon': faHourglassHalf,
    'active': true,
    'description': "Product Age Summary description"
  },

  containerTargetReach: {
    'label': 'Container Target Reach',
    'link': '/dashboard/container-target-reach',
    'icon': faBox,
    'active': false,    
    'description': "containerTargetReach description"
    // 'description': "Shows the total number of items packed on containers and the number of items missing compared to the container target defined for customers and products."
  },
  bundleRatio: {
    'label': 'Bundle Ratio in Outscans',
    'link': '/dashboard/bundle-ratio-outscans',
    'icon': faCheckCircle,
    'active': false,
    'description': "bundleRatio description"
    // 'description': "Shows the ratio of bundled to unbundled items registered during outscans over a period of time."
  },

  incomingOutgoingProducts: {
    'label': 'Incoming and Outgoing Products',
    'link': '/dashboard/incoming-outgoing-products',
    'icon': faWarehouse,
    'active': true,
    'description': "incomingOutgoingProducts description"
    // 'description': 'Shows the total number of items and items per product type returned to the location (clean and soil returns) and delivered to customers.'
  },
  deliveredProducts: {
    'label': 'Proof Delivery',
    'link': '/dashboard/delivered-products',
    'icon': faTruckLoading,
    'active': true,
    'description': "deliveredProducts description"
    // 'description': 'Shows the total number of items and items per product type delivered to customers in a given period.'
  },
  returnedProducts: {
    'label': 'Proof Return',
    'link': '/dashboard/returned-products',
    'icon': faUndo,
    'active': true,
    'description': "returnedProducts description"
    // 'description': 'Shows the total number of items per customer returned to the location (clean and soil returns).'
  },
  itemHistory: {
    'label': 'Item History',
    'link': '/management/items/cm2keyldo000ifyvjqllk7bo5',
    'icon': faUndo,
    'active': true,
    'description': "item history description"
    // 'description': 'Shows the total number of items per customer returned to the location (clean and soil returns).'
  },
  
  cabinetUserSummary: {
    'label': 'Cabinet User-Product Summary',
    'link': '/dashboard/cabinet-user-summary',
    'icon': faUserShield,
    'active': true,
    'description': ""
  },

  cabinetEventSummary: {
    'label': 'Cabinet Events Summary',
    'link': '/dashboard/cabinet-event-summary',
    'icon': faCogs,
    'active': false,
    'description': ""
  },
  UnauthorizedCabinetAccessSummary: {
    'label': 'Unauthorized Cabinet Access Summary',
    'link': '/dashboard/unauthorized-access-summary',
    'icon': faCogs,
    'active': true,
    'description': ""
  },
};

export class YourComponent {
  constructor(private translate: TranslateService) {
    // Translate the 'label' for productAgeSummary
    this.translate.get('Dashboard.Product Age Summary').subscribe((translation: string) => {
      KPIS.productAgeSummary.label = translation;
    });
  }
}